import React from 'react';

/**
 * FCRVersionGuidanceNote — small amber-bordered helper card explaining how
 * to choose an FCR version. Used under the FCR Version dropdown across
 * Spreadsheet Uploader, Snapshot Analysis, Growth-vs-Model Analysis, and
 * Growth Prognosis so the guidance is consistent everywhere.
 */
export default function FCRVersionGuidanceNote() {
  return (
    <div
      className="text-[11px] leading-relaxed text-amber-900 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 mt-1"
      data-testid="fcr-version-guidance-note"
    >
      <p className="font-semibold text-amber-800 mb-1">How to choose the right version</p>
      <ul className="list-disc list-outside pl-4 space-y-1">
        <li>
          If your cage's reported model FCR is <strong>typically higher</strong> than the generic 100% model,
          select a version <strong>above 100%</strong> to raise the model FCR.
        </li>
        <li>
          If your performance is <strong>consistently better</strong> than the generic 100% model,
          select a version <strong>below 100%</strong> to lower it.
        </li>
        <li>
          Changing the version will affect how much missing fish PFD estimates for this cage.
        </li>
        <li>
          For the most accurate analysis, upload your <strong>own generic FCR model</strong> via the Admin Custom Models page.
        </li>
      </ul>
    </div>
  );
}
